import {
  type AdConfigPlacement,
  AdServer,
  type AfsPlacement,
  type GamPlacement,
  type MartailerPlacement
} from './types/api/index.js';

export namespace Placements.Afs {
  export function is(placement: AdConfigPlacement): placement is AfsPlacement {
    return placement.adServer.type === AdServer.Afs;
  }

  export function filter(placements: ReadonlyArray<AdConfigPlacement>) {
    return placements.filter(is);
  }
}

export namespace Placements.Gam {
  export function is(placement: AdConfigPlacement): placement is GamPlacement {
    return placement.adServer.type === AdServer.Gam;
  }

  export function filter(placements: ReadonlyArray<AdConfigPlacement>) {
    return placements.filter(is);
  }
}

export namespace Placements.Martailer {
  export function is(
    placement: AdConfigPlacement
  ): placement is MartailerPlacement {
    return placement.adServer.type === AdServer.Martailer;
  }

  export function filter(placements: ReadonlyArray<AdConfigPlacement>) {
    return placements.filter(is);
  }
}
